import { render } from "./TemplateUploadModal.vue?vue&type=template&id=ee07e26c"
import script from "./TemplateUploadModal.vue?vue&type=script&lang=js"
export * from "./TemplateUploadModal.vue?vue&type=script&lang=js"
script.render = render

export default script